export function generateUuid() {
  return window.btoa(Math.random()).substring(0, 12);
}
